import { Table } from "reactstrap";
import "./CHMTableComponents.css";
import { handleUpdatePageSlice } from "../redux/slices/globalSlice";
import { useDispatch } from "react-redux";
import {
  icvGetCCEUsersApiCall,
  ncipSearchApiCall,
} from "../api/icvActivityAPI";
import { useEffect, useState } from "react";
import axios from "axios";
import { Tooltip } from "@mui/material";
import { ICV_STATUS } from "../utils/Constant";

const ICVTableComponent = ({ viewForm, ICVDashboardData }: any) => {
  const dispatch: any = useDispatch();

  const getEachCHMInfo = (each: any) => {
    viewForm(each);
    dispatch(handleUpdatePageSlice(true));
  };

  return (
    <div className="table-scroll-container">
      <Table striped hover bordered responsive className="icv-table">
        <thead>
          <tr className="aligne-center">
            <th className="sticky-left">KML-ID</th>
            <th>Season</th>
            <th>Year</th>
            <th>State</th>
            <th>District</th>
            <th>Tehsil / Block</th>
            <th>Village</th>
            <th>Survey Number</th>
            <th>Application Number</th>
            <th>Crop Sown Status</th>
            <th>Land Is Cultivatable</th>
            <th>Crop Pattern</th>
            <th>Crop Name As per Application</th>
            <th>Crop Name On Field</th>
            <th>Surveyor Name</th>
            <th>Surveyor Mobile Number</th>
            <th>Surveyor Role</th>
            <th>ICV Conducted Date</th>
            <th>QC Executive Name</th>
            <th>QC Initiated Date</th>
            <th>QC Completion Date</th>
            <th>QC Remarks</th>
          </tr>
        </thead>
        <tbody>
          {ICVDashboardData?.map((each: any, index: any) => {
            const surveyorMobileNumber = each.surveyorMobileNumber;
            const cropNameOnField = each.cropNameOnField;
            const cropName =!cropNameOnField || cropNameOnField?.[0] == null? "--" :cropNameOnField ;
            const cropPattern = each.cropPattern;
            const mixedrop = each.cropNameOnField?.join(",");
            return (
              <tr key={`ICVTable-${index}`} className="aligne-center">
                <td
                  className="view-form"
                  style={{position:'sticky', left:'0'}}
                  onClick={() => {
                    getEachCHMInfo(each);
                  }}
                >{each.kmlId}</td>
                <td>{each.ncipSeason ?? '--'}</td>
                <td>{each.ncipYear ?? '--'}</td>
                <td>{each.ncipCropStateName ?? '--'}</td>
                <td>{each.ncipCropDistrictName ?? '--'}</td>
                <td>{each.ncipCropMandalName ?? '--'}</td>
                <td>{each.ncipCropVillageName ?? '--'}</td>
                <td>{each.ncipSurveyNumber ?? '--'}</td>
                <td>{each.ncipApplicationId ?? '--'}</td>
                <td>{each.cropSownStatus ?? '--' }</td>
                <td>{each.landCultivatableStatus ?? '--'}</td>
                <td>{each.cropPattern !== null ? cropPattern : "--"}</td>
                <td>{each.ncipCropName ?? '--'}</td>
                <td className="remarks-field">
                  <Tooltip
                    title={each.cropPattern === "Single Crop" || each.cropPattern == null
                    ? cropName
                    : mixedrop}
                    placement="bottom-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: 'black'
                        }
                      }
                    }}
                  >
                  {each.cropPattern === "Single Crop" || each.cropPattern == null
                    ? cropName
                    : mixedrop}
                  </Tooltip>
                </td>
                <td>
                  {each.surveyorName ??
                    "--"}
                </td>
                <td>{each.surveyorMobileNumber}</td>
                <td>
                  {each.surveyorRole ?? "--"}
                </td>
                <td>
                  {each.icvConductedDate
                    ?.split("T")[0]
                    ?.split("-")
                    ?.reverse()
                    ?.join("-")
                    ?? '--'
                  }
                </td>
                <td>{each.qcName ?? '--'}</td>
                <td>{each.qcInitiationDate?.split("T")[0]?.split("-")?.reverse()?.join("-") ?? '--'}</td>
                <td>{(each.qcCompletionDate?.split("T")[0]?.split("-")?.reverse()?.join("-") ?? '--')}</td>
                <td className="remarks-field">
                  <Tooltip
                    title={each.qcRemarks}
                    placement="bottom-start"
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: 'black'
                        }
                      }
                    }}
                  ><span>{each.qcRemarks?.trim()?.length > 0 ? each.qcRemarks?.trim() : '--'}</span>
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default ICVTableComponent;
